/* eslint-disable no-console */
import { ApolloLink } from '@apollo/client';
import { auth } from '@frameio/utils/auth';
import { isServer } from '@frameio/utils/config/helpers';

export default new ApolloLink((operation, forward) => {
  if (isServer) {
    throw new Error(
      "AuthLink should never be called from server, due to Auth's multi-request singleton pattern"
    );
  }

  // Hydrate the apollo context with authentication credentials
  if (!operation?.getContext()?.headers?.authorization) {
    const accessToken = auth.getAccessToken();

    operation.setContext({
      headers: {
        ...operation?.getContext()?.headers,
        ...(accessToken && { authorization: `Bearer ${accessToken}` }),
      },
    });
  }

  return forward(operation);
});
